export const iconFontAwesomeWeatherTemperatureHalf = (
	<i className="fa-solid fa-temperature-half"></i>
);
